import { UserModel } from '../../authen/_models/authen.model';
import {
  PaymentProjectModel,
  ReviewProjectModel,
  SubmissionLabModel,
} from '../_models/task.model';
import { RapidPrototypingTopicModel } from '../_models/option.model';

export class RapidPrototypeModel {
  id: number;
  operationNo: string;
  no: string;
  rapidPrototyTopicId: number;
  rapidPrototyTopic: RapidPrototypingTopicModel;

  paymentProjects: PaymentProjectModel[];
  modelName: string;
  otherDetails: string;
  reason: string;

  part1: string;
  partLSize1: string;
  partWSize1: string;
  partHSize1: string;
  partDSize1: string;
  partQuantity1: string;
  partResolution1: string;
  materialResolution1Id: number;
  part2: string;
  partLSize2: string;
  partWSize2: string;
  partHSize2: string;
  partDSize2: string;
  partQuantity2: string;
  partResolution2: string;
  materialResolution2Id: number;
  part3: string;
  partLSize3: string;
  partWSize3: string;
  partHSize3: string;
  partDSize3: string;
  partQuantity3: string;
  partResolution3: string;
  materialResolution3Id: number;
  part4: string;
  partLSize4: string;
  partWSize4: string;
  partHSize4: string;
  partDSize4: string;
  partQuantity4: string;
  partResolution4: string;
  materialResolution4Id: number;
  part5: string;
  partLSize5: string;
  partWSize5: string;
  partHSize5: string;
  partDSize5: string;
  partQuantity5: string;
  partResolution5: string;
  materialResolution5Id: number;

  data1: string;
  data2: string;
  data3: string;
  data4: string;
  attachFileImage: string;
  attachFile: File;

  file1: File;
  attachFile1: string;
  file2: File;
  attachFile2: string;
  file3: File;
  attachFile3: string;
  file4: File;
  attachFile4: string;
  file5: File;
  attachFile5: string;

  creationDateTime: string;
  lastUpdateDateTime: string;

  isStart: boolean;
  userStartId: number;
  userStart: UserModel;
  StartDateTime: string;
  userCreateId: number;
  userCreate: UserModel;
  userEditId: number;
  userEdit: UserModel;

  isConfirm: boolean;
  isApplyReview: boolean;
  applyReviewDateTime: string;
  isInProcessRecord: boolean;
  inProcessRecordDateTime: string;
  isTestCertificate: boolean;
  testCertificateDateTime: string;
  isTaskSubmission: boolean;
  taskSubmissionDateTime: string;
  isPayment: boolean;
  paymentDateTime: string;

  reviewProject: ReviewProjectModel;
  submission: SubmissionLabModel;

  propertiesTotal: number;
  propertiesReturned: number;
  propertiesDiscard: number;
  propertiesFReturned: number;
  propertiesFDiscard: number;

  rapidPrototyOldId: number;
  userApplyReviewId: number;
  userApplyReview: UserModel;
  userInProcessRecordId: number;
  userInProcessRecord: UserModel;
  userTestCertificateId: number;
  userTestCertificate: UserModel;
  userTaskSubmissionId: number;
  userTaskSubmission: UserModel;
  userPaymentId: number;
  userPayment: UserModel;

  file_arr: Array<File> = [];

  clear() {
    this.id = 0;
    this.operationNo = '';
    this.no = '';
    this.rapidPrototyTopicId = null;
    this.rapidPrototyTopic = new RapidPrototypingTopicModel();
    this.modelName = '';
    this.part1 = '';
    this.partLSize1 = '';
    this.partWSize1 = '';
    this.partHSize1 = '';
    this.partDSize1 = '';
    this.partQuantity1 = '';
    this.partResolution1 = '';
    this.materialResolution1Id = null;
    this.part2 = '';
    this.partLSize2 = '';
    this.partWSize2 = '';
    this.partHSize2 = '';
    this.partDSize2 = '';
    this.partQuantity2 = '';
    this.partResolution2 = '';
    this.materialResolution2Id = null;
    this.part3 = '';
    this.partLSize3 = '';
    this.partWSize3 = '';
    this.partHSize3 = '';
    this.partDSize3 = '';
    this.partQuantity3 = '';
    this.partResolution3 = '';
    this.materialResolution3Id = null;
    this.part4 = '';
    this.partLSize4 = '';
    this.partWSize4 = '';
    this.partHSize4 = '';
    this.partDSize4 = '';
    this.partQuantity4 = '';
    this.partResolution4 = '';
    this.materialResolution4Id = null;
    this.part5 = '';
    this.partLSize5 = '';
    this.partWSize5 = '';
    this.partHSize5 = '';
    this.partDSize5 = '';
    this.partQuantity5 = '';
    this.partResolution5 = '';
    this.materialResolution5Id = null;
    this.otherDetails = '';

    this.data1 = '';
    this.data2 = '';
    this.data3 = '';
    this.data4 = '';
    this.attachFileImage = '';
    this.attachFile = null;

    this.file1 = null;
    this.attachFile1 = '';
    this.file2 = null;
    this.attachFile2 = '';
    this.file3 = null;
    this.attachFile3 = '';
    this.file4 = null;
    this.attachFile4 = '';
    this.file5 = null;
    this.attachFile5 = '';

    this.creationDateTime = '2021-01-01';
    this.lastUpdateDateTime = '2021-01-01';

    this.userCreateId = 0;
    this.userCreate = new UserModel();
    this.userEditId = 0;
    this.userEdit = new UserModel();

    this.isConfirm = false;
    this.isApplyReview = false;
    this.applyReviewDateTime = '';
    this.isInProcessRecord = false;
    this.inProcessRecordDateTime = '';
    this.isTestCertificate = false;
    this.testCertificateDateTime = '';
    this.isTaskSubmission = false;
    this.taskSubmissionDateTime = '';
    this.isPayment = false;
    this.paymentDateTime = '';

    this.reviewProject = new ReviewProjectModel();
    this.submission = new SubmissionLabModel();

    this.propertiesTotal = null;
    this.propertiesReturned = null;
    this.propertiesDiscard = null;
    this.propertiesFReturned = null;
    this.propertiesFDiscard = null;

    this.rapidPrototyOldId = 0;
    this.userApplyReviewId = 0;
    this.userApplyReview = new UserModel();
    this.userInProcessRecordId = 0;
    this.userInProcessRecord = new UserModel();
    this.userTestCertificateId = 0;
    this.userTestCertificate = new UserModel();
    this.userTaskSubmissionId = 0;
    this.userTaskSubmission = new UserModel();
    this.userPaymentId = 0;
    this.userPayment = new UserModel();

    this.file_arr = [];
  }
}
